<script lang="ts" setup>
import { computed } from 'vue'

import { Participant } from '@collector/sportsapi-client-legacy'

import { useCricketConfiguration } from '../../CricketRelationDependencies/useCricketConfiguration'
import LiveViewSubParticipant from '../CurrentBatters/LiveViewSubParticipant.vue'
import CurrentBattersSelection from './CurrentBattersSelection.vue'

type Props = {
  participant: Participant
  dir: 'ltr' | 'rtl'
}

const props = defineProps<Props>()

// inject
const { activeParticipant } = useCricketConfiguration()

// methods
const shouldRenderCurrentBatters = computed((): boolean => {
  return (
    (activeParticipant.value.participant &&
      activeParticipant.value.participant.id === props.participant.id) ||
    false
  )
})
</script>

<template>
  <div class="text-[12px]">
    <CurrentBattersSelection
      v-if="shouldRenderCurrentBatters"
      :participant
      :dir
    />
    <LiveViewSubParticipant
      v-else
      :participant
      type="main"
      :dir
      bowler
    />
  </div>
</template>
